import React, { useState } from "react";
import { Star } from "lucide-react";
import { google } from "../mock";

export default function GoogleReviewCard({ review, index }) {
  const [imgOk, setImgOk] = useState(true);
  return (
    <a
      href={google.mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`google-review-card-${index}`}
      className="reveal group relative flex flex-col bg-white rounded-2xl p-8 border border-slate-200 hover:border-sky-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-sky-500/10 transition-all duration-500"
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="flex items-center gap-3">
        {imgOk ? (
          <img
            src={review.avatar}
            alt={review.name}
            referrerPolicy="no-referrer"
            onError={() => setImgOk(false)}
            className="h-11 w-11 rounded-full object-cover"
          />
        ) : (
          <div className="h-11 w-11 rounded-full bg-gradient-to-br from-sky-400 to-cyan-600 flex items-center justify-center text-white font-semibold">
            {review.name.charAt(0)}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-slate-900 text-sm">{review.name}</div>
          <div className="text-xs text-slate-500">{review.when} · Google</div>
        </div>
      </div>
      <div className="mt-4 flex gap-0.5" aria-label={`${review.rating} stars`}>
        {Array.from({ length: 5 }, (_, s) => (
          <Star key={s} className={`h-4 w-4 ${s < review.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
        ))}
      </div>
      <p className="mt-3 text-slate-700 leading-relaxed flex-1">{review.text}</p>
      {review.reply && (
        <div className="mt-4 rounded-lg bg-slate-50 border-l-2 border-sky-500 px-3 py-2 text-xs text-slate-600">
          <span className="font-semibold text-slate-800">Response from the owner:</span> {review.reply}
        </div>
      )}
    </a>
  );
}
